module.exports = __webpack_public_path__ + "b4d71c12a5995ea575b3ccdba5902d47.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/@sabre/aven-spark/icons/build/fonts/spark-icon-line.woff2
// module id = 1407
// module chunks = 0